import React, { Component } from 'react';
import '../../custom.css';
import imageLogo from '../../img/logo.png';
//import functionMin from '../../js/functions-min.js';
//import jqueryMin from '../../lib/jquery/jquery-2.2.4.min.js';
import statsDatalistHandler from '../../lib/jquery/statsDatalistHandler.js';
import AllPlayers from '../AllPlayers';
import $ from 'jquery';

export class Error extends React.Component {

    


    render() {

        const queryParameters = new URLSearchParams(window.location.search)
        const errorCode = queryParameters.get("errorCode")

        return (
            <div>
                <div className="perspective effect-rotate-left">
                    <div className="container">
                        <div className="outer-nav--return"></div>
                        <div id="viewport" className="l-viewport">
                            <div className="l-wrapper">
                                <header className="header">
                                    <a className="header--logo" href="/">
                                        <img src={imageLogo} alt="Global" />
                                        <p>NPA</p>
                                    </a>
                                </header>
                            
                                        <div className="intro">
                                            <div className="intro--banner">
                                        <h1>Oops!! An Error Has Occurred.</h1>
                                            {errorCode && errorCode == "2323" && <h4>Not Enough Data is Available For this Query</h4> }
                                            <br></br>
                                            <button>
                                                <a href='/'>
                                                    <div className="link">
                                                        Return Home
                                                    </div>
                                                </a> 
                                                <span className="btn-background"></span>
                                            </button>
                                        </div>

                                    </div>

                            

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



